export const iconFontAwesomeArrowsSquareCaretUp = (
	<i className="fa-solid fa-square-caret-up"></i>
);
